import { Drawer, Modal, theme } from 'antd'
import { useWindowDimensions } from 'utils'
import { ScreenSize } from 'types'
import { CustomerFormController } from 'pages/customer/customer-form/customer-form'
import { BookingAction, BookingPageDispatch, BookingPageState } from 'pages/booking/booking-page/booking-page'
import { PropsWithChildren } from 'react'

type Props = {
    pageState: BookingPageState
    pageStateDispatch: BookingPageDispatch
}

export const BookingAddCustomer = ({ pageState, pageStateDispatch }: Props) => {

    //hooks:
    const { token: { padding, colorBgLayout } } = theme.useToken()
    const { LG, width, height } = useWindowDimensions()

    const isModal = LG && height >= ScreenSize.MD

    return isModal ? (
                
        <Modal
            open={pageState.isAddCustomerOpen}
            closeIcon={null}
            footer={null}
            destroyOnClose
            style={{
                minWidth: LG ? ScreenSize.LG : width,
                padding
            }}
            styles={{ content: { padding: 0 } }}
            onCancel={() => pageStateDispatch({ type: BookingAction.SET_IS_ADD_CUSTOMER_OPEN, payload: { isAddCustomerOpen: false } })}
        >
            <FormWrapper>
                <CustomerFormController
                    customer={null}
                    onCreate={customer => pageStateDispatch({ type: BookingAction.SET_CUSTOMER, payload: { customer } })}
                    onBack={() => pageStateDispatch({ type: BookingAction.SET_IS_ADD_CUSTOMER_OPEN, payload: { isAddCustomerOpen: false } })}
                />
            </FormWrapper>
        </Modal>

    ) : (

        <Drawer
            closable={false}
            width={width}
            destroyOnClose
            open={pageState.isAddCustomerOpen}
            styles={{ body: { padding: 0, backgroundColor: colorBgLayout } }}
            onClose={() => pageStateDispatch({ type: BookingAction.SET_IS_ADD_CUSTOMER_OPEN, payload: { isAddCustomerOpen: false } })}
        >
            <FormWrapper>
                <CustomerFormController
                    customer={null}
                    onCreate={customer => pageStateDispatch({ type: BookingAction.SET_CUSTOMER, payload: { customer } })}
                    onBack={() => pageStateDispatch({ type: BookingAction.SET_IS_ADD_CUSTOMER_OPEN, payload: { isAddCustomerOpen: false } })}
                />
            </FormWrapper>
        </Drawer>
        
    )

}

const FormWrapper = ({ children }: PropsWithChildren) => {
    const { token: { colorBgLayout, colorBgBase, paddingXL, borderRadiusLG } } = theme.useToken()
    const { SM } = useWindowDimensions()
    return (
        <div style={{
            backgroundColor: SM ? colorBgLayout : colorBgBase,
            paddingBottom: paddingXL,
            borderRadius: borderRadiusLG*2,
            overflow: 'hidden'
        }}>
            {children}
        </div>
    )
}
